if (!window.cardQtyInitialized) {
  window.cardQtyInitialized = true;

  document.addEventListener("click", function (e) {
    const minusBtn = e.target.closest("[data-card-qty-minus]");
    const plusBtn = e.target.closest("[data-card-qty-plus]");

    if (!minusBtn && !plusBtn) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    const qtyWrapper = e.target.closest("[data-card-qty]");
    if (!qtyWrapper) return;

    const input = qtyWrapper.querySelector(".card-qty-input");
    if (!input) return;

    let min = parseInt(input.min || 1, 10);
    let max = parseInt(input.max || 9999, 10);
    let qty = parseInt(input.value || min, 10);

    if (plusBtn && qty < max) qty++;
    if (minusBtn && qty > min) qty--;

    input.value = qty;

    input.dispatchEvent(new Event("change", { bubbles: true }));
  });

  document.addEventListener("input", function (e) {
    if (!e.target.classList.contains("card-qty-input")) return;

    let min = parseInt(e.target.min || 1, 10);
    let max = parseInt(e.target.max || 9999, 10);
    let qty = parseInt(e.target.value || min, 10);

    if (qty < min) qty = min;
    if (qty > max) qty = max;

    e.target.value = qty;
  });
}